import React, { FC, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { ColorAvatar, ColorAvatarProps } from './ColorAvatar';

export interface LazyAvatarProps extends ColorAvatarProps {
  /**
   * Action to be called when Avatar is in view.
   * The action will be called one time.
   * Example: dispatch(loadImageAction);
   *
   * @memberof LazyAvatarProps
   */
  load(): void;

  /**
   * If false, the components dispatches a load function.
   *
   * @memberof LazyAvatarProps
   */
  isLoaded: boolean;
}

export const LazyAvatar: FC<LazyAvatarProps> = props => {
  const { image, load, isLoaded, size, ...rest } = props;

  const { ref, inView } = useInView({
    threshold: 0,
    rootMargin: '50px 0px 0px 0px', // top, right, bottom, left
  });

  useEffect(() => {
    if (inView && !isLoaded) {
      load();
    }
  }, [inView, isLoaded, load]);

  return (
    <div ref={ref} style={{ display: 'inline-block' }}>
      <ColorAvatar image={image} size={size} {...rest} />
    </div>
  );
};
